import "./App.css";

import Weather from "./components/weather/Weather";

function App() {
  return (
    <div className="app">
      <Weather />
    </div>
  );
}

export default App;
